exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".grupo[data-v-120ac130]{color:#000;font-weight:700;padding-top:20px}.subGrupo[data-v-120ac130]{color:#000;font-weight:700;padding-top:10px}.subCuenta[data-v-120ac130]{font-weight:700;padding-top:5px}.cuenta[data-v-120ac130]{color:#9e9e9e}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-120ac130","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/configurations/accounts/Account.vue
// module id = 650
// module chunks = 0